@import '../../theme/colors';

.root {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.error {
  margin-top: 20px;
  margin-bottom: -20px;
}

.detailsSectionContent {
  padding: 16px 0;
  display: flex;
  @media (max-width: 800px) {
    flex-direction: column;
    & > div {
      margin-bottom: 8px;
    }
  }
}

.descriptionField {
  flex: 1;
}

.actionFooter {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid $neutral-300;
  background-color: #fcfcfc;
  margin: 0 -40px -20px;
  padding: 14px 20px;
}

.editFooter {
  @extend .actionFooter;
  justify-content: flex-end;
}

.buildSection {
  margin-top: 20px;
  flex: 1;
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  form {
    fieldset:first-child {
      border-top: none;
      margin-top: 0;
      padding-top: 0;
    }
  }
}
